<!-- 抽屉基本模板 -->
<!-- 包含初始化，开关动画功能 -->
<template>
    <div class="drawer" :name=drawerName :class="drawerShow?'drawer-open':'drawer-close'">
        <div class="drawer-body">
            <div class="drawer-switch" @click="close()"></div>
            <!-- 页面集合 -->
            <div class="drawer-pages" :class="pageShow?'drawer-pages-open':'drawer-pages-close'">
                <addEmailPage ref="addEmailPage"></addEmailPage>
                <addCloudPage ref="addCloudPage"></addCloudPage>
            </div>
        </div>
    </div>
</template>

<script>
import addEmailPage from "@/components/drawer/page/add_email";
import addCloudPage from "@/components/drawer/page/add_cloud";
export default {
    name: "darwerBasicFormwork",
    props: ["drawerName","pageName","pageData"],
    components: {
        addEmailPage,
        addCloudPage,
    },
    data() {
        return {
            drawerShow: false,
            pageShow: false,
        }
    },
    mounted() {
    },
    methods: {
        init(pageName) {
            //触发初始化和动画
            this.drawerShow = true;
            this.pageShow = true;
            //启动对应页面
            if(!pageName&&this.pageName){
                //未传入信息，但是有固定pageName
                pageName = this.pageName;
            }
            let page = eval("this.$refs."+pageName);
            if(page){
                if(this.pageData){
                    //存在传入信息
                    page.init(this.pageData);
                }else{
                    page.init();
                }
            }
        },
        close() {
            //触发关闭动画
            this.pageShow = false;
            setTimeout(() => {
                this.drawerShow = false;
            },1000);
        }
    },
}
</script>

<style scoped>
.drawer {
    background-color: rgba(0,0,0,.3);
    position: fixed;
    z-index: 100;
    left: 0;
    top: 0;
    overflow-x: hidden;
    overflow-y: auto;
}

.drawer-open {
    width: 100%;
    height: 100%;
    min-width: 789px;/*no*/
}

.drawer-close {
    width: 0;
    height: 0;
}

.drawer-body {
    width: calc(55% + 20px);/*no*/
    height: 100%;
    float: right;
    display: flex;
    justify-content: right;
}

.drawer-switch {
    position: relative;
    top: calc(50% - 63px);/*no*/
    width: 20px;/*no*/
    height: 126px;/*no*/
    background-repeat: no-repeat;
    background-image: url("../../../assets/images/workspace/icon_folded_right_arrow_normal.png");
    cursor: pointer;
}

.drawer-switch:hover {
    background-image: url("../../../assets/images/workspace/icon_folded_right_arrow_hover.png");
}

.drawer-pages {
    background: #fff;
    animation: openFun 0.5s 1 alternate both;
}

/* 动画效果 */
.drawer-pages-open {
    animation: openFun 0.5s 1 alternate both;
}

.drawer-pages-close {
    animation: closeFun 1s 1 alternate both;
}

@keyframes openFun {
    0% {
        width: 0;
    }

    100% {
        width: calc(100% - 20px);/*no*/
    }
}

@-webkit-keyframes openFun {
    0% {
        width: 0;
    }

    100% {
        width: calc(100% - 20px);/*no*/
    }
}
@keyframes closeFun {
    0% {
        width: calc(100% - 20px);/*no*/
    }

    100% {
        width: 0;
    }
}

@-webkit-keyframes closeFun {
    0% {
        width: calc(100% - 20px);/*no*/
    }

    100% {
        width: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/drawer/formwork/basic_drawer.vue